<template >
  <div>
    <InnerHeader />
    <main role="main">
      <div class="page-content">
        <div class="container py-md-5 py-4">
          <div class="row justify-content-center">
            <div class="col-lg-10">
              <div class="row align-items-center mb-4">
                <div class="col-md-6">
                  <h2 class="page-title mb-md-0 mb-3">
                    <a href="javascript:void(0)"
                      ><img
                        src="/images/back-arrow.svg"
                        width="20"
                        alt=""
                        class="me-2"
                    /></a>
                    View Bio-data
                  </h2>
                </div>
                <div class="col-md-2 text-md-end text-center">
                  <div class="font-bold mb-3">5/3</div>
                </div>
                <div class="col-md-4">
                  <div
                    class="
                      d-flex
                      suggestion-prof-nav
                      align-items-center
                      justify-content-md-end justify-content-center
                    "
                  >
                    <a href="" class="me-2 prev-profile prof-nav-btn"
                      ><i class="fa fa-angle-left" aria-hidden="true"></i
                    > <span class="font-14 align-middle">Prev</span></a>
                    <div class="profile-img">
                      <img src="images/user-male-2.png" width="40" alt="" />
                    </div>
                    <div class="profile-img current">
                      <img src="images/user-profile.jpg" width="40" alt="" />
                    </div>
                    <a href="" class="ms-2 next-profile prof-nav-btn current"
                      ><span class="font-14 align-middle"> Next </span><i class="fa fa-angle-right" aria-hidden="true"></i
                    ></a>
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-3 mb-4">
                  <div
                    id="suggesteProfileSlider"
                    class="carousel slide suggesteProfileSlider"
                    data-bs-ride="carousel" data-bs-interval="false"
                  >
                    <div class="carousel-inner rounded-l">
                      <div class="carousel-item active">
                        <img
                          src="images/profile-female-1.jpg"
                          class="photos"
                          alt="..."
                        />
                      </div>
                      <div class="carousel-item">
                        <img
                          src="images/profile-female-2.jpg"
                          class="photos"
                          alt="..."
                        />
                      </div>
                      <div class="carousel-item">
                        <img
                          src="images/profile-female-3.jpg"
                          class="photos"
                          alt="..."
                        />
                      </div>
                    </div>
                   
                  </div>
                  <div class="text-center my-3 position-relative carousel-outer-nav">
                    <button
                      class="carousel-control-prev"
                      type="button"
                      data-bs-target="#suggesteProfileSlider"
                      data-bs-slide="prev"
                    >
                      <span
                        class="carousel-control-prev-icon"
                        aria-hidden="true"
                      ></span>
                      <span class="visually-hidden">Previous</span>
                    </button>
                    <span>3/3</span>
                    <button
                      class="carousel-control-next"
                      type="button"
                      data-bs-target="#suggesteProfileSlider"
                      data-bs-slide="next"
                    >
                      <span
                        class="carousel-control-next-icon"
                        aria-hidden="true"
                      ></span>
                      <span class="visually-hidden">Next</span>
                    </button>
                    
                    </div>
                  

                    <div class="mt-5">
                          <button
                    type="button"
                    class="btn btn-outline-brand-1 mb-3 w-100"
                    data-bs-toggle="modal"
                    data-bs-target="#ViewContact"
                  >
                    <i class="fa fa-eye font-20 me-2" aria-hidden="true"></i>
                    View Contact
                  </button>
                 
                  <div class="btn-group w-100" role="group" aria-label="Basic checkbox toggle button group">
                    <input type="checkbox" class="btn-check" id="btncheck1" autocomplete="off">
                    <label class="btn btn-outline-brand-1 mb-3 w-100" for="btncheck1"><i class="fa fa-heart font-20 me-2" aria-hidden="true"></i> Shortlist</label>
                  </div>
                  <button type="button" class="btn btn-brand-1 w-100 mb-3">
                    <i
                      class="fa fa-paper-plane font-20 me-2"
                      aria-hidden="true"
                    ></i>
                    Send interest
                  </button>
                  
                  <div class="dropdown">
                  <button type="button" class="btn btn-outline-brand-1 w-100 dropdown-toggle" id="dropdownMore"  data-bs-toggle="dropdown" aria-expanded="false">
                    <i
                      class="fa fa-ellipsis-v font-20 me-2"
                      aria-hidden="true"
                    ></i>
                    More
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="dropdownMore">
                    <li><a class="dropdown-item" href="#"><i class="fa fa-share-alt" aria-hidden="true"></i> Share Profile</a></li>
                    <li><a class="dropdown-item" href="#"><i class="fa fa-ban" aria-hidden="true"></i> Block User</a></li>
                    <li><a class="dropdown-item" href="#"><i class="fa fa-flag" aria-hidden="true"></i> Report This User</a></li>
                  </ul>
                </div>
                      </div>
                  
                </div>
                <div class="col-md-9 position-relative">
                  <nav id="navbar_scrolltab" class="navbar navbar-light bg-white p-0 fixed-scroll-tab">
                  <ul
                    class="nav nav-pills mb-3 tab-style-1  w-100"
                  >
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        href="#ScrollSec_1"
                        >Personal details</a
                      >
                    </li>
                    <li class="nav-item" >
                      <a
                        class="nav-link"
                        href="#ScrollSec_2"
                        >family details</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        href="#ScrollSec_3"
                        >Expectations</a
                      >
                    </li>
                  </ul>
                  </nav>
                
                    <div data-bs-spy="scroll" data-bs-target="#navbar_scrolltab" data-bs-offset="90" class="scrollspy-example form-style" tabindex="0">
                    <div
                      class="mb-4"
                      id="ScrollSec_1"
                    >
                    <div class="row">
                      <div class="col-md-8">
                           <div class="row">
                        <div class="col-lg-6 col-md-6 col-6">
                          <label>Registration No.</label>
                        </div>
                        <div class="col-lg-6 col-md-6 col-6">
                          <p class="font-medium">S091293821</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-6 col-md-6 col-6">
                          <label>Marital Status</label>
                        </div>
                        <div class="col-lg-6 col-md-6 col-6">
                          <p class="font-medium">Never Married</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-6 col-md-6 col-6">
                          <label>Surname</label>
                        </div>
                        <div class="col-lg-6 col-md-6 col-6">
                          <p class="font-medium">Shinde</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-6 col-md-6 col-6">
                          <label>Date of Birth</label>
                        </div>
                        <div class="col-lg-6 col-md-6 col-6">
                          <p class="font-medium">11/12/1991</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-6 col-md-6 col-6">
                          <label>Height</label>
                        </div>
                        <div class="col-lg-6 col-md-6 col-6">
                          <p class="font-medium">5’ 2”</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-6 col-md-6 col-6">
                          <label>Body Structure</label>
                        </div>
                        <div class="col-lg-6 col-md-6 col-6">
                          <p class="font-medium">Athlectic</p>
                        </div>
                      </div>
                      </div>
                   
                    </div>
                     
                      <div class="row">
                        <div class="col-lg-4 col-md-5 col-6">
                          <label>Blood Group</label>
                        </div>
                        <div class="col-lg-8 col-md-7 col-6">
                          <p class="font-medium">o+</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-4 col-md-5 col-6">
                          <label>Skin Tone</label>
                        </div>
                        <div class="col-lg-8 col-md-7 col-6">
                          <p class="font-medium">Fair</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-4 col-md-5 col-6">
                          <label>Diet</label>
                        </div>
                        <div class="col-lg-8 col-md-7 col-6">
                          <p class="font-medium">Veg</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-4 col-md-5 col-6">
                          <label>Education</label>
                        </div>
                        <div class="col-lg-8 col-md-7 col-6">
                          <p class="font-medium">M.COM</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-4 col-md-5 col-6">
                          <label>Occupational Details</label>
                        </div>
                        <div class="col-lg-8 col-md-7 col-6">
                          <p class="font-medium">Business</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-4 col-md-5 col-6">
                          <label>Annual Income (Lakh)</label>
                        </div>
                        <div class="col-lg-8 col-md-7 col-6">
                          <p class="font-medium">50 Lakh</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-4 col-md-5 col-6">
                          <label>Working Location</label>
                        </div>
                        <div class="col-lg-8 col-md-7 col-6">
                          <p class="font-medium">Hinjewadi, Pune</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-4 col-md-5 col-6">
                          <label>Birth Time & Birth District</label>
                        </div>
                        <div class="col-lg-8 col-md-7 col-6">
                          <p class="font-medium">03:45:00 Mumbai</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-4 col-md-5 col-6">
                          <label>Gun Milan</label>
                        </div>
                        <div class="col-lg-8 col-md-7 col-6">
                          <p class="font-medium">24</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-4 col-md-5 col-6">
                          <label>Mangal</label>
                        </div>
                        <div class="col-lg-8 col-md-7 col-6">
                          <p class="font-medium">No</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-4 col-md-5">
                          <label>Horoscope Details</label>
                        </div>
                        <div class="col-lg-8 col-md-7">
                          <p class="font-medium">
                            Tula Nakshatra Charan, Nadi Gan
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-4 col-md-5">
                          <label>Devak</label>
                        </div>
                        <div class="col-lg-8 col-md-7">
                          <p class="font-medium">-</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-4 col-md-5">
                          <label>Ready To move abroad</label>
                        </div>
                        <div class="col-lg-8 col-md-7">
                          <p class="font-medium">Yes</p>
                        </div>
                      </div>
                    </div>
                    <!-- Family Details  -->
                    <div
                      class="mb-4"
                      id="ScrollSec_2"
                    >
                      <h3 class="font-bold font-18 mb-4">Family Details</h3>
                      <div class="row">
                        <div class="col-lg-4 col-md-5">
                          <label>Native Place</label>
                        </div>
                        <div class="col-lg-8 col-md-7">
                          <p class="font-medium">
                            <span class="me-3">
                              Aasu - <span class="font-regular">Gaon</span>,</span
                            >
                            <span class="me-3">
                              Phaltan -
                              <span class="font-regular">Taluka</span>,</span
                            >
                            <span class="">
                              Satara -
                              <span class="font-regular">Dist.</span></span
                            >
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-4 col-md-5">
                          <label>Father Occupation</label>
                        </div>
                        <div class="col-lg-8 col-md-7">
                          <p class="font-medium">
                            <span class="me-3">Business, Pune</span>
                           
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-4 col-md-5">
                          <label>Mother Occupation</label>
                        </div>
                        <div class="col-lg-8 col-md-7">
                          <p class="font-medium">
                            <span class="me-3"> Housewife, Pune</span>
                            
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-4 col-md-5">
                          <label class="font-bold">Brother/Sister Details</label>
                        </div>
                        <div class="col-lg-8 col-md-7">
                          <p class="">
                            (If sister is married, mention surname only)
                          </p>
                        </div>
                      </div>
                      <div class="table-wrap mb-3 table-responsive">
                        <table
                          class="
                            table
                            table-style-1
                            table-responsive
                            table-striped
                            table-hover
                            text-center
                          "
                          id="sorting_tbl"
                        >
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Married?</th>
                              <th>Education</th>
                              <th>Occup.</th>
                              <th>Place </th>
                              <th>Birth Year</th>
                              <th>Hgt</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Hiren</td>
                              <td>Yes?</td>
                              <td>BE</td>
                              <td>Job</td>
                              <td>Pune </td>
                              <td>1995</td>
                                 <td>5’7”</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                       <div class="row">
                        <div class="col-lg-4 col-md-5">
                          <label class=" ">Mama’s Surname</label>
                        </div>
                        <div class="col-lg-8 col-md-7">
                         <p class="font-medium">
                          <span class="me-1"> Deshmukh -</span>
                          <span class="me-4 font-regular"> Native Place - <span class="font-medium">Pune</span></span>
                          <span class="font-regular"> Taluka - <span class="font-medium">Haveli</span></span></p>
                        </div>
                      </div>
                       <div class="row">
                        <div class="col-lg-4 col-md-5">
                          <label class=" ">Relatives </label>
                        </div>
                        <div class="col-lg-8 col-md-7">
                         <p class="font-medium">
                          <span class="me-4"> Deshmukh - <span class="font-regular">Phaltan</span></span>
                          <span class="font-medium"> Jadhav - <span class="font-regular">Junnar</span></span></p>
                        </div>
                      </div>
                       <div class="row">
                        <div class="col-lg-4 col-md-5">
                          <label class=" ">Properties </label>
                        </div>
                        <div class="col-lg-8 col-md-7">
                         <p class="font-medium">
                          <span class="me-4"> Farm, Land <span class="font-regular">- Pune</span></span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      class=""
                      id="ScrollSec_3"
                    >
                      <h3 class="font-bold font-18 mb-4">Expectations</h3>
                      <div class="row">
                        <div class="col-lg-6 col-md-5">
                          <label>Expected Marital Status</label>
                        </div>
                        <div class="col-lg-6 col-md-7">
                          <p class="font-medium">Never Married</p>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-lg-6 col-md-5">
                          <label>Expected Birth Years</label>
                        </div>
                        <div class="col-lg-6 col-md-7">
                          <p class="font-medium">1991 to 1995</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-6 col-md-5">
                          <label>Expected Height</label>
                        </div>
                        <div class="col-lg-6 col-md-7">
                          <p class="font-medium">5’7” to 5’9”</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-6 col-md-5">
                          <label>Patrika Matching</label>
                        </div>
                        <div class="col-lg-6 col-md-7">
                          <p class="font-medium">Yes</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-6 col-md-5">
                          <label>Preferred Working Cities/Country</label>
                        </div>
                        <div class="col-lg-6 col-md-7">
                          <p class="font-medium">Pune, Mumbai</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-6 col-md-5">
                          <label>Preferred Native Places</label>
                        </div>
                        <div class="col-lg-6 col-md-7">
                          <p class="font-medium">Pune, Mumbai</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-6 col-md-5">
                          <label>Expected Education</label>
                        </div>
                        <div class="col-lg-6 col-md-7">
                          <p class="font-medium">BE</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-6 col-md-5">
                          <label>Occupational & Other Expectations</label>
                        </div>
                        <div class="col-lg-6 col-md-7">
                          <p class="font-medium">Property, Land, Farm</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

    <div class="modal fade" id="ViewContact" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Contact Details</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
            <p class="font-medium">S091293821</p><div class="row">
              <div class="col-md-6"><label>Candidate Name: (Full name)</label></div>
              <div class="col-md-6 text-md-left"><p class="font-medium">Snehal Shinde</p></div>
              </div>
              <div class="row">
              <div class="col-md-6"><label>Contact Full name</label></div>
                <div class="col-md-6 text-md-left"><p class="font-medium">Tukaram Shinde</p></div>
                </div>
              <div class="row">
                <div class="col-md-12"><p class="font-medium">Phone Number</p></div>
              </div>
              <div class="row">
                <div class="col-md-6"><label class="">Father</label></div>
                <div class="col-md-6 text-md-left"><p class="font-medium">+91 9392929191</p></div>
              </div>
                <div class="row">
                  <div class="col-md-6"><label class="">Mother</label></div>
                  <div class="col-md-6 text-md-left"><p class="font-medium">+91 9392929191</p></div>
                </div>
                <div class="row">
                  <div class="col-md-6"><label class="">Other</label></div>
                  <div class="col-md-6 text-md-left"><p class="font-medium">+91 9392929191</p></div>
                </div>
                <div class="row">
                  <div class="col-md-6"><label class="f">Email</label></div>
                  <div class="col-md-6 text-md-left"><p class="font-medium">abcsnehal@gmail.com</p></div>
                </div>
                <div class="row">
                  <div class="col-md-6"><label class="">Contact Viewed on</label></div>
                  <div class="col-md-6 text-md-left"><p class="font-medium">11/12/2021</p></div>
                </div>
                <div class="text-center"><a href="">SMS/Email these details to me</a></div>
              </div>
    </div>
  </div>
</div>
    <MainFooter />
  </div>

</template>
<script>
import InnerHeader from "@/components/InnerHeader";
import MainFooter from "@/components/MainFooter";
// /import $ from "jquery";
//import router from "../../router";
export default {
  name: "ViewBiodata",
  components: {
    InnerHeader,
    MainFooter,
  },
  data() {},
  mounted() {
 
  },
  methods: {
    
  },
};
</script>
